import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { ctaFragment, imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteResourceCard = contentfulGql`#graphql
  ${imageFragment}
  ${ctaFragment}
  fragment EntWebsiteResourceCard on EntWebsiteResourceCard {
    headline
    eyebrow
    slug
    showButton
    image {
      ...Image
    }
    cta {
      ...Cta
    }
  }
`;

export const entWebsiteResourceHub = contentfulGql`#graphql
  ${ctaFragment}
  ${entWebsiteResourceCard}
  fragment EntWebsiteResourceHub on EntWebsiteResourceHub {
    headline
    slug
    cta {
      ...Cta
    }
    resourceCardsCollection {
      items {
        ...EntWebsiteResourceCard
      }
    }
    usePagination
  }
`;

export const entWebsiteBlockResourceHubQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteResourceHub}

  query entWebsiteBlockResourceHub($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteResourceHub
      }
    }
  }
`;
